import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@/api";
import { STORAGE_QUERY_KEY, type StorageBooking } from "./storage";

export const retrieveStorageBooking = async (bookingId: string) => {
  const { body } = await api.get<StorageBooking>(
    `/storage/bookings/${bookingId}`,
  );
  return body;
};

export const useStorageBooking = (bookingId: MaybeRef<string | null>) =>
  useQuery({
    queryKey: [STORAGE_QUERY_KEY, "booking", bookingId] as const,
    queryFn: ({ queryKey: [, , bookingId_] }) =>
      retrieveStorageBooking(unref(bookingId_) as string),
    enabled: computed(() => !!unref(bookingId)),
    refetchOnWindowFocus: false,
  });
